<template>
  <div>
    <Card>
        <Collapse v-model="value1">
        <Panel name="1">
           操作中心
           <p slot="content">
            <Card>
            <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
              <Checkbox
                :indeterminate="indeterminateOpscenter"
                :value="checkAllOpscenter"
                @click.prevent.native="handleCheckAllOpscenter">全选</Checkbox>
           </div>
          <CheckboxGroup v-model="checkBoxOpscenterSel" @on-change="checkBoxOpscenterChange">
              <Checkbox v-for="item in checkBoxOpscenterAll" :key="item.id" :label="item.id">{{item.name}}</Checkbox>
          </CheckboxGroup>
           </Card>
           </p>
        </Panel>
        <!-- <Panel name="2">
            数据库管理
        </Panel> -->
        <Panel name="2">
           持续交付
           <p slot="content">
            <Card>
            <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
              <Checkbox
                :indeterminate="indeterminateDeploy"
                :value="checkAllDeploy"
                @click.prevent.native="handleCheckAllDeploy">全选</Checkbox>
           </div>
          <CheckboxGroup v-model="checkBoxDeploySel" @on-change="checkBoxDeployChange">
              <Checkbox v-for="item in checkBoxDeployAll" :key="item.id" :label="item.id">{{item.name}}</Checkbox>
          </CheckboxGroup>
           </Card>
           </p>
        </Panel>
        <Panel name="3">
           堡垒机
          <p slot="content">
            <Card>
            <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
              <Checkbox
                :indeterminate="indeterminateSpringboard"
                :value="checkAllSpringboard"
                @click.prevent.native="handleCheckAllSpringboard">全选</Checkbox>
           </div>
          <CheckboxGroup v-model="checkBoxSpringboardSel" @on-change="checkBoxSpringboardChange">
              <Checkbox v-for="item in checkBoxSpringboardAll" :key="item.id" :label="item.id">{{item.name}}</Checkbox>
          </CheckboxGroup>
           </Card>
           </p>
        </Panel>
         <Panel name="4">
           网络设备
           <p slot="content">
            <Card>
            <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
              <Checkbox
                :indeterminate="indeterminateNetwork"
                :value="checkAllNetwork"
                @click.prevent.native="handleCheckAllNetwork">全选</Checkbox>
           </div>
          <CheckboxGroup v-model="checkBoxNetworkSel" @on-change="checkBoxNetworkChange">
              <Checkbox v-for="item in checkBoxNetworkAll" :key="item.id" :label="item.id">{{item.name}}</Checkbox>
          </CheckboxGroup>
           </Card>
           </p>
        </Panel>
       <Panel name="5">
           工单
           <p slot="content">
            <Card>
            <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
              <Checkbox
                :indeterminate="indeterminateWorksheet"
                :value="checkAllWorksheet"
                @click.prevent.native="handleCheckAllWorksheet">全选</Checkbox>
           </div>
          <CheckboxGroup v-model="checkBoxWorksheetSel" @on-change="checkBoxWorksheetChange">
              <Checkbox v-for="item in checkBoxWorksheetAll" :key="item.id" :label="item.id">{{item.name}}</Checkbox>
          </CheckboxGroup>
           </Card>
           </p>
        </Panel>
       <!-- <Panel name="5">
           应用管理
           <p slot="content">斯蒂夫</p>
        </Panel>
        <Panel name="6">
           Agent管理
           <p slot="content">斯蒂夫</p>
        </Panel> -->
    </Collapse>
    <br>
    <Button type="primary" @click="handleSubmit">提交</Button>
    <Button style="margin-left: 8px" @click="handleCancel">取消</Button>
    </Card>
  </div>
</template>
<script>
import { changeRole, getAllPermission } from '@/api/user'
export default {
  name: 'OperatePerm',
  props:
  {
    'formItem': Object,
    'handleChangePermissions': {
      type: Function
    }
  },
  components: {
  },
  data () {
    return {
      value1: ['1', '2', '3', '5', '4'],
      permissionSel: [],
      indeterminateOpscenter: true,
      indeterminateDeploy: true,
      indeterminateSpringboard: true,
      indeterminateNetwork: true,
      indeterminateWorksheet: true,
      checkAllOpscenter: false,
      checkAllNetwork: false,
      checkAllDeploy: false,
      checkAllSpringboard: false,
      checkAllWorksheet: false,
      checkBoxOpscenterAll: [],
      checkBoxNetworkAll: [],
      checkBoxDeployAll: [],
      checkBoxSpringboardAll: [],
      checkBoxWorksheetAll: [],
      checkBoxOpscenterSel: [],
      checkBoxNetworkSel: [],
      checkBoxSpringboardSel: [],
      checkBoxDeploySel: [],
      checkBoxWorksheetSel: [],
      changeLoadingShow: false,
      formItemOwn: this.formItem,
      listStyle: {
        width: '350px',
        height: '650px'
      }
    }
  },
  watch: {
    formItem: {
      handler (newName, oldName) {
        this.formItemOwn = this.formItem
        this.checkBoxOpscenterSel = this.checkBoxOpscenterAll.filter(item => this.formItemOwn.permissions.indexOf(item.id) > -1).map(m => m.id)
        this.checkBoxNetworkSel = this.checkBoxNetworkAll.filter(item => this.formItemOwn.permissions.indexOf(item.id) > -1).map(m => m.id)
        this.checkBoxDeploySel = this.checkBoxDeployAll.filter(item => this.formItemOwn.permissions.indexOf(item.id) > -1).map(m => m.id)
        this.checkBoxSpringboardSel = this.checkBoxSpringboardAll.filter(item => this.formItemOwn.permissions.indexOf(item.id) > -1).map(m => m.id)
        this.checkBoxWorksheetSel = this.checkBoxWorksheetAll.filter(item => this.formItemOwn.permissions.indexOf(item.id) > -1).map(m => m.id)
      }
      // immediate: true
    }
  },
  methods: {
    handleCheckAllOpscenter () {
      if (this.indeterminateOpscenter) {
        this.checkAllOpscenter = false
      } else {
        this.checkAllOpscenter = !this.checkAllOpscenter
      }
      this.indeterminateOpscenter = false
      if (this.checkAllOpscenter) {
        this.checkBoxOpscenterSel = this.checkBoxOpscenterAll.map(item => item.id)
      } else {
        this.checkBoxOpscenterSel = []
      }
    },
    handleCheckAllNetwork () {
      if (this.indeterminateNetwork) {
        this.checkAllNetwork = false
      } else {
        this.checkAllNetwork = !this.checkAllNetwork
      }
      this.indeterminateNetwork = false
      if (this.checkAllNetwork) {
        this.checkBoxNetworkSel = this.checkBoxNetworkAll.map(item => item.id)
      } else {
        this.checkBoxNetworkSel = []
      }
    },
    handleCheckAllWorksheet () {
      if (this.indeterminateWorksheet) {
        this.checkAllWorksheet = false
      } else {
        this.checkAllWorksheet = !this.checkAllWorksheet
      }
      this.indeterminateWorksheet = false
      if (this.checkAllWorksheet) {
        this.checkBoxWorksheetSel = this.checkBoxWorksheetAll.map(item => item.id)
      } else {
        this.checkBoxWorksheetSel = []
      }
    },
    handleCheckAllDeploy () {
      if (this.indeterminateDeploy) {
        this.checkAllDeploy = false
      } else {
        this.checkAllDeploy = !this.checkAllDeploy
      }
      this.indeterminateDeploy = false
      if (this.checkAllDeploy) {
        this.checkBoxDeploySel = this.checkBoxDeployAll.map(item => item.id)
      } else {
        this.checkBoxDeploySel = []
      }
    },
    handleCheckAllSpringboard () {
      if (this.indeterminateSpringboard) {
        this.checkAllSpringboard = false
      } else {
        this.checkAllSpringboard = !this.checkAllSpringboard
      }
      this.indeterminateSpringboard = false
      if (this.checkAllSpringboard) {
        this.checkBoxSpringboardSel = this.checkBoxSpringboardAll.map(item => item.id)
      } else {
        this.checkBoxSpringboardSel = []
      }
    },
    checkBoxOpscenterChange (data) {
      if (data.length === this.checkBoxOpscenterAll.length) {
        this.indeterminateOpscenter = false
        this.checkAllOpscenter = true
      } else if (data.length > 0) {
        this.indeterminateOpscenter = true
        this.checkAllOpscenter = false
      } else {
        this.indeterminateOpscenter = false
        this.checkAllOpscenter = false
      }
    },
    checkBoxNetworkChange (data) {
      if (data.length === this.checkBoxNetworkAll.length) {
        this.indeterminateNetwork = false
        this.checkAllNetwork = true
      } else if (data.length > 0) {
        this.indeterminateNetwork = true
        this.checkAllNetwork = false
      } else {
        this.indeterminateNetwork = false
        this.checkAllNetwork = false
      }
    },
    checkBoxWorksheetChange (data) {
      if (data.length === this.checkBoxWorksheetAll.length) {
        this.indeterminateWorksheet = false
        this.checkAllWorksheet = true
      } else if (data.length > 0) {
        this.indeterminateWorksheet = true
        this.checkAllWorksheet = false
      } else {
        this.indeterminateWorksheet = false
        this.checkAllWorksheet = false
      }
    },
    checkBoxDeployChange (data) {
      // console.log(data)
      if (data.length === this.checkBoxDeployAll.length) {
        this.indeterminateDeploy = false
        this.checkAllDeploy = true
      } else if (data.length > 0) {
        this.indeterminateDeploy = true
        this.checkAllDeploy = false
      } else {
        this.indeterminateDeploy = false
        this.checkAllDeploy = false
      }
    },
    checkBoxSpringboardChange (data) {
      if (data.length === this.checkBoxSpringboardAll.length) {
        this.indeterminateSpringboard = false
        this.checkAllSpringboard = true
      } else if (data.length > 0) {
        this.indeterminateSpringboard = true
        this.checkAllSpringboard = false
      } else {
        this.indeterminateSpringboard = false
        this.checkAllSpringboard = false
      }
    },
    getNoSelectPermission () {
      getAllPermission().then(res => {
        if (res.status === 200) {
          this.checkBoxOpscenterAll = res.data.filter(item => item.app_model.indexOf('opscenter') > -1)
          this.checkBoxNetworkAll = res.data.filter(item => item.app_model.indexOf('network') > -1)
          this.checkBoxDeployAll = res.data.filter(item => item.app_model.indexOf('deploy') > -1)
          this.checkBoxSpringboardAll = res.data.filter(item => item.app_model.indexOf('springboard') > -1)
          this.checkBoxWorksheetAll = res.data.filter(item => item.app_model.indexOf('worksheet') > -1)
        }
      })
    },
    handleCancel () {
      this.handleChangePermissions(false)
    },
    handleSubmit (name) {
      this.permissionSel = []
      this.permissionSel = this.permissionSel.concat(this.checkBoxOpscenterSel, this.checkBoxNetworkSel, this.checkBoxWorksheetSel, this.checkBoxDeploySel, this.checkBoxSpringboardSel)
      this.formItemOwn.permissions = this.permissionSel
      changeRole(this.formItemOwn, this.formItemOwn.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.handleChangePermissions(false)
      })
    }
  },
  mounted: function () {
    this.getNoSelectPermission()
  }
}
</script>
